import React from 'react'
import { api, getBranchOwner, put, post } from "@config"
import { notification } from 'antd'
import { validateCNPJ, validateCPF } from '../../components/parts/document-component/index'

import {
    EMAIL_RE
} from './regex'

const translate = {
    'pt-BR':
    {
        'CPF Already registred': 'Este CPF já está cadastrado',
        'CNPJ Already registred': 'Este CNPJ já está cadastrado'
    },
    'en-US': {
        'CPF Already registred': 'CPF Already registred',
        'CNPJ Already registred': 'CNPJ Already registred',
    }
}

export default class Person {

    constructor() {
        this.model = ''
        this.address = {}
        this.autoBasePersonValidate = true
        this.basePersonIsValid = true
        this.basePersonErrors = []
        this.branchIsValid = true
        this.branchErrors = []
        this.requestErrors = []
        this.edit = false
        this.type = 0
    }

    getModelUrl() {
        const branch = getBranchOwner().id
        switch (this.model) {
            case 'supplier':
                this.url = `${api.suppliers}?branch_owner=${branch}`
                break
            case 'client':
                this.url = `${api.clients}?branch_owner=${branch}`
                break
            case 'branch':
                this.url = `${api.branches}`
                break
        }
    }
    setBranchData(props) {
        if (this.type === 0) {
            this.data.individual = {}
            this.data.individual.cpf = props.doc
        } else {
            this.data.company = {}
            this.data.company.crt = props.crt
            this.data.company.main_company = props.main_company || false
            this.data.company.fancy_name = props.fancyName
            this.data.company.state_registry = props.stateRegistry
            this.data.company.main_cnae = props.cnae
            this.data.company.cnpj = props.doc
        }
    }

    showBasePersonNotificationErrors(includesBrancheErrors = false) {
        let errors = []
        this.basePersonErrors.map((error, i) => errors.push(<li key={i}>{error}</li>))
        notification.open({
            type: "error",
            message: "Corrija os errors abaixo:",
            description: <ul>{errors}</ul>,
            key: 777,
            duration: 4
        })
    }

    basePersonValidate(is_fiscal = false, check_crt = true) {
        this.basePersonErrors = []
        const { name, email, phone_number } = this.data

        if (!name || name.length < 3) {
            this.basePersonErrors.push("Nome inválido")
        }
        if (!email || !EMAIL_RE.test(email)) {
            this.basePersonErrors.push('Informe um email válido')
        }
        if (!phone_number || phone_number.length < 8) {
            this.basePersonErrors.push('Informe um telefone válido')
        }

        if ([1,2].includes(this.type)) {
            const { fancy_name, cnpj, crt } = this.data.company;
            if (!fancy_name || fancy_name.length < 3) {
                this.basePersonErrors.push("Nome fantasia inválido")
            }

            const docComp = document.querySelector("[data-doc-valid]") 
            let cleanCnpj = cnpj ? cnpj.replace(/\D/g, "") : "";
            if (cleanCnpj.length == 0) {
                this.basePersonErrors.push("Insira um CNPJ")
            } else if (docComp && docComp.getAttribute("already-exists") == "true") {
                this.basePersonErrors.push("CNPJ já cadastrado")
            } else if (cleanCnpj.length != 14 || docComp && docComp.getAttribute("data-doc-valid") == "false") { 
                this.basePersonErrors.push("CNPJ inválido")
            }
            if (check_crt && !crt) {
                this.basePersonErrors.push("CRT inválido")
            }
        } else {
            const { individual } = this.data;
            if(!individual){
                return
            }
            if (!validateCPF(individual.cpf) ) {
                this.basePersonErrors.push("CPF inválido")
            }
        }


        this.basePersonIsValid = this.basePersonErrors.length === 0
    }

    initFromProps(props) {
        this.name = props.name
        this.email = props.email
        this.phone_number = props.phoneNumber
        this.type = props.type

        this.data = {
            "name": this.name,
            "email": this.email,
            "phone_number": this.phone_number
        }
        if (this.type === 0) {
            this.data.individual = { cpf: props.doc }
        } else {
            this.data["company"] = {
                "fancy_name": props.fancyName || this.name,
                "cnpj": props.doc,
                "main_cnae": props.cnae,
                "state_registry": props.stateRegistry,
            }
        }
        switch (this.model) {
            case "branch":
                this.setBranchData(props)
                break
        }

        if (this.autoBasePersonValidate) {
            this.basePersonValidate()
        }

    }
    showRequestErrors() {
        const errors = this.requestErrors.map((err, i) => <li key={i}>{
            translate["pt-br"][err]
        }</li>)
        notification.open({
            type: 'error',
            description: <ul>{errors}</ul>,
            duration: 3,
            key: 778
        })
    }

    _handleErrors(request) {
        this.requestErrors = []
        const errors = JSON.parse(request.responseText)
        if (errors['non_field_errors']) {
            this.requestErrors = errors['non_field_errors']
        }

        this.requestErrors.length > 0
            ? this.showRequestErrors()
            : null

    }

    save(successPayload = null, errorPayload = null) {
        this.getModelUrl()
        if (this.edit) {
            put(`${api.clients}${this.id}/?branch_owner=${getBranchOwner().id}`, this.data, successPayload, err => {
                if (typeof (errorPayload) === "function") {
                    errorPayload()
                }
                this._handleErrors(err)
            })
            return
        }

        post(this.url, this.data, successPayload, err => {
            if (typeof (errorPayload) === "function") {
                errorPayload()
            }
            this._handleErrors(err)
        })
    }


}


// WEBPACK FOOTER //
// ./src/models/base/person.js